const tickets = {
  title: 'Éditer le billet',
  add_title: 'Ajouter un billet',
  event: 'Évènement',
  status: 'Statut',
  ticket_identifier: 'Numéro du billet',
  contact: 'Contact',
  seller: 'Vendeur',
  first_name: 'Prénom',
  last_name: 'Nom',
  email: 'Courriel',
  phone: 'Téléphone',
  sold_price: 'Prix de vente',
  send_title: 'Envoyer les billets',
  send_to: 'Envoyer à',
  all: 'Tous',
  selected: 'Sélectionnés',
  send_by: 'Envoyer par',
  sms: 'SMS',
  message: 'Message',
  download_title: 'Télécharger les billets',
  download_to: 'Télécharger',
  export_title: 'Exporter les billets',
  export_to: 'Exporter',
  format: 'Format',
  delivery: 'Livraison',
  by_email: 'Par courriel',
};

export default tickets;
